// extracted by mini-css-extract-plugin
export default {"content":"Contract_content__-fAsp","tabs":"Contract_tabs__zcXk9"};